import React from 'react'
import styled from 'styled-components'

const VideoWrapper = styled.div`
  width: 100%;
  height: 100vh;
  overflow: hidden;
  // height: 100vh;
  // @media screen and (orientation:portrait) {
  //   // height: ${props => props.height};
  //   height: 100vh;
  //   width: auto;
  // }
  // @media screen and (orientation:landscape) {
  //   height: 100vh;
  //   width: 100vw;
  // }
  
  &:before {
    content: '';
    background: ${props =>
      props.visible === true ? 'rgba(0, 0, 0, 0.5)' : 'rgba(0, 0, 0, 0)'};
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    height: 100%;
    width: 100%;
    z-index: 2;
    transition: background-color 500ms linear;
  }  
`

const Slide = styled.video`
  height: 100vh;
  @media screen and (orientation:portrait) {
    // height: ${props => props.height};
    height: 100vh;
    width: auto;
  }
  @media screen and (orientation:landscape) {
    height: auto;
    width: 100vw;
  }
  @media screen and (min-width: ${props => props.theme.responsive.medium}) {
    height: auto;
    width: auto;
    object-fit: cover;
  }

  display: block;
  position: absolute;
  top: 50%;
  left: 50%;
  min-width: 100%;
  min-height: 100%;
  width: auto;
  height: 100vh;
  transform: translate(-50%, -50%);
`

class SlideVideo extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      height: '100vh',
    }
  }

  componentDidMount() {
    this.setState({
      height: window.innerHeight + 'px',
    })

    if (this.props.slideNumber === this.props.id) {
      var menu = document.getElementById('menu')
      var headerWrapper = document.getElementById('headerWrapper')
      if (this.props.dark) {
        menu.classList.add('light')
        headerWrapper.classList.add('light')
      } else {
        menu.classList.add('dark')
        headerWrapper.classList.add('dark')
      }
    }
  }

  playRender() {
    if (this.props.slideNumber === this.props.id) {
      if (typeof window !== `undefined`) {
        let video = document.getElementById(this.props.id)
        if (video) {
          video.currentTime = 0
          
          var playPromise = video.play();

          if (playPromise !== undefined) {
            playPromise.then(_ => {
              // Automatic playback started!
              // Show playing UI.
            })
            .catch(error => {
              // console.log(error)
              // Auto-play was prevented
              // Show paused UI.
            });
          }

        }
      }
    }
  }

  render() {
    const src = this.props.projectVideo.photo.file.url
    const visible = this.props.visible
    
    this.playRender()

    return (
      <VideoWrapper visible={visible} height={this.state.height}>
        <Slide playsInline loop muted id={this.props.id} src={src}/>
      </VideoWrapper>
    )
  }
}

export default SlideVideo
